import { PERIOD as period } from '@constants/billing';
import styled from 'styled-components';
import { PeriodValue } from '@/shared/types';

export const StyledBox = styled.div<{ $active: PeriodValue; $isMobile?: boolean }>`
  background: linear-gradient(135deg, #00c8e0, #007d8f);
  position: absolute;
  top: 3px;
  border-radius: 96px;
  transition: left 0.3s ease-in-out, right 0.3s ease-in-out;
  box-shadow: 0 4px 12px rgba(0, 200, 224, 0.3);
  z-index: 1;
  width: ${props => props.$isMobile ? '175px' : '210px'};
  height: 42px;
  left: ${props => props.$active === period.month ? '3px' : props.$isMobile ? '175px' : '225px'};
`;

export const StyledStackContainer = styled.div<{ $width?: string; $height?: string; $isDark?: boolean }>`
  display: flex;
  flex-direction: row;
  width: ${props => props.$width || '440px'};
  height: ${props => props.$height || '50px'};
  border: 1px solid ${props => props.$isDark ? 'rgba(0, 200, 224, 0.3)' : '#e0e0e0'};
  background: ${props => props.$isDark ? '#151c24' : '#f5f5f5'};
  border-radius: 96px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
`;

export const StyledStack = styled.div<{ $width?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: ${props => props.$width || '50%'};
  z-index: 2;
  transition: opacity 0.3s ease-in-out;
`;

export const StyledTypography = styled.span<{ $isActive: boolean; $isDark?: boolean }>`
  font-family: 'JetBrains Mono', monospace;
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
  color: ${props => props.$isActive
    ? '#ffffff'
    : props.$isDark ? '#94a3b8' : '#64748b'};
  transition: color 0.3s ease-in-out;
`;

export const DiscountChip = styled.span<{ $isActive?: boolean }>`
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 8px;
  background: ${props => props.$isActive
    ? 'rgba(255, 255, 255, 0.25)'
    : 'rgba(255, 184, 0, 0.2)'};
  border: 1px solid ${props => props.$isActive
    ? 'rgba(255, 255, 255, 0.5)'
    : 'rgba(255, 184, 0, 0.4)'};
  border-radius: 4px;
  color: ${props => props.$isActive ? '#ffffff' : '#d97706'};
  transition: all 0.3s ease;
`;
